// ==============================|| OVERRIDES - INPUT LABEL (ERPNext style: label above the field) ||============================== //
// The label is always rendered above the input (never floating inside it) – every form in the app gets the same,
// calm, aligned look without touching each page.

export default function InputLabel(theme) {
  const v = theme.vars.palette;
  return {
    MuiInputLabel: {
      defaultProps: { shrink: true },
      styleOverrides: {
        root: {
          position: 'relative',
          transform: 'none !important',
          maxWidth: '100%',
          marginBottom: 6,
          fontSize: '0.75rem',
          fontWeight: 500,
          lineHeight: 1.35,
          color: v.grey[700],
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          '&.Mui-focused': { color: v.grey[800] },
          '&.Mui-error': { color: v.error.main },
          '&.Mui-disabled': { color: v.grey[500] },
          '& .MuiFormLabel-asterisk': { color: v.error.main }
        },
        outlined: { '&.MuiInputLabel-shrink': { background: 'transparent', padding: 0, marginLeft: 0 } }
      }
    },
    MuiFormLabel: {
      styleOverrides: { root: { fontSize: '0.75rem', fontWeight: 500, color: v.grey[700], '&.Mui-focused': { color: v.grey[800] } } }
    }
  };
}
